<template>
  <v-slide-y-transition group tag="div" class="loan-container">
    <h3 key="title" v-if="ready" class="text-center font-weight-black pt-2">
      우리동네 크라우드 펀딩
    </h3>
    <div v-if="request" class="content" key="content">
      <SectionWrapper v-if="!(loan && isInvestingShow)" title="신청 내용">
        <RequestSummary :request="request" />
      </SectionWrapper>

      <v-slide-y-transition>
        <SectionWrapper
          v-if="loan && isInvestingShow"
          title="대출 모집 현황"
          :to="{ name: 'loan/detail', params: { uuid: loan.uuid } }"
        >
          <InvestingProgressCircular :loanUuid="loan.uuid" :loan="loan" />
          <LoanContractButton class="mt-6" :uuid="loan.uuid" />
        </SectionWrapper>
      </v-slide-y-transition>

      <SectionWrapper
        v-if="loan"
        title="대출 정보"
        :to="{ name: 'loan/detail', params: { uuid: loan.uuid } }"
      >
        <LoanSummary :loan="loan.uuid" />
      </SectionWrapper>

      <SectionWrapper
        title="사업 참여 신청서 작성"
        no-content
        v-if="!requestFileApplication && isFileEditable"
        :to="{ name: 'woori-crowd/detail/application', params: { uuid: this.uuid } }"
        subtitle="신청서 작성 후 서류제출이 가능합니다."
      >
      </SectionWrapper>

      <SectionWrapper title="제출 서류">
        <RequestFile
          :request="request"
          :uuid="uuid"
          :fileCategory="fileCategory"
          :requestFiles.sync="requestFiles"
          :disabled="!requestFileApplication"
        />
      </SectionWrapper>
    </div>
  </v-slide-y-transition>
</template>

<script>
import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  props: ['uuid'],
  components: {
    RequestSummary: () => import('@/components/loans-request/detail/RequestSummary.vue'),
    RequestFile: () => import('@/components/loans-request/detail/RequestFile.vue'),
    InvestingProgressCircular: () => import('@/components/loan/InvestingProgressCircular.vue'),
    SectionWrapper: () => import('@/components/loans-request/detail/SectionWrapper.vue'),
    LoanContractButton: () => import('@/components/loan/LoanContractButton.vue'),
    LoanSummary: () => import('@/components/loan/detail/LoanSummary.vue'),
  },
  data() {
    return {
      ready: false,
      request: null,
      fileCategory: [
        { title: '국세완납증명서', required: true },
        { title: '지방세 완납증명서', required: true },
        { title: '소상공인 확인서', required: true },
        { title: '주민등록등본', required: true },
        { title: '주민등록초본', required: true, description: '변동이력 포함' },
        { title: '주민등록초본 2페이지', required: false, description: '추가 페이지 있는 경우' },
        { title: '주민등록초본 3페이지', required: false, description: '추가 페이지 있는 경우' },
        { title: '주민등록초본 4페이지', required: false, description: '추가 페이지 있는 경우' },
        { title: '주민등록초본 5페이지', required: false, description: '추가 페이지 있는 경우' },
        { title: '통장사본', required: false, description: '대출금 및 수수료 반환 받으실통장' },
        { title: '사업자등록증명원', required: true },
        { title: '사업참여신청서', required: true },
        { title: '자가진단표', required: true },
      ],
      loan: null,
      requestFiles: [],
    }
  },
  mounted() {
    this.ready = true
  },
  watch: {
    requestFileApplication: {
      deep: true,
      async handler(v) {
        if (v === false && this.isFileEditable) {
          await this.$router.replace(`${this.$route.path}/application`)
        }
      },
    },
  },
  async created() {
    _meta({
      titles: ['우리동네크라우드', '상세'],
    })
    console.log('RequestDetail created')
    await this.fetchData()
  },
  computed: {
    isFileEditable() {
      return !['reject', 'cancel'].includes(this.request?.status)
    },
    isInvestingShow() {
      if (['investing', 'invested', 'executing'].includes(this.loan?.status)) {
        return true
      }
      return false
    },
    requestFileApplication() {
      return ['사업참여신청서', '자가진단표'].every((applicationTitle) => {
        return this.requestFiles.find((f) => f.title === applicationTitle)
      })
    },
  },
  methods: {
    async fetchData() {
      const { data } = await defaultApi.getLoansRequestDetail(this.uuid)
      this.request = data
      console.log('request detail data ', this.request)

      if (this.request.status === 'approve') {
        const { data } = await defaultApi.getLoansRequestLoan(this.uuid)
        if (data?.uuid) {
          this.loan = data
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.loan-container {
  padding-bottom: 80px; // 채널톡 버튼 높이 + 여유 공간
}
</style>
